/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from "react";
import {
  Navbar,
  Nav,
  NavDropdown,
  Container,
  Dropdown,
  Col,
  Row,
  Spinner,
  Alert,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import toastr from "toastr";
import logo from "../images/logo2.png";
import userDefaultPerfil from "../images/perfil2.png";
import { singOut } from "../redux/auth/actions";
import { getAuth } from "../redux/auth/actions";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
  getNotifications,
  notificationsRead,
} from "../redux/notifications/actions";

const CustomNavbar = (props) => {
  const dispatch = useDispatch();
  const userPic = useSelector((store) => store.auth.pic);
  const userId = useSelector((store) => store.auth.id);
  const userName = useSelector((store) => store.auth.name);
  const userType = useSelector((store) => store.auth.userType);
  const history = useHistory();
  const { loaderNotifications, notifications, notificationsFail } = useSelector(
    (store) => store.notifications
  );

  useEffect(() => {
    dispatch(getAuth());
  }, [dispatch]);

  useEffect(() => {
    if (userId && userId != " ") {
      dispatch(
        getNotifications({
          limit: 10,
          offset: 0,
          id_destinatario: parseInt(userId),
          leido: 0,
        })
      );
    }
  }, [dispatch, userId]);

  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    toastr.success("Pantalla refrescada con exito!");
    setTimeout(function () {
      window.location.reload(false);
    }, 1200);
  };

  const onSignOut = (e) => {
    e.preventDefault();
    dispatch(singOut());
  };

  return (
    <Navbar fixed="top" collapseOnSelect expand="lg" bg="dark" variant="dark">
      <Container fluid>
        {/* <Navbar.Brand href="#home"><Link to="/Dashboard-Headcount"><img src={logo} className="logo" alt="logo" /></Link></Navbar.Brand> */}
        <Navbar.Brand>
          <Link to={`/detalle-empleado/${userId}/${userType}`}>
            <img src={logo} className="logo" alt="logo" />
          </Link>
        </Navbar.Brand>
        {props.type === "dashboard" ? (
          <Navbar.Brand
            className="custom-sidebar-show-btn"
            onClick={() => props.onShowSidebar()}
          >
            <i className="material-icons">menu</i>
          </Navbar.Brand>
        ) : (
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        )}
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            {/*        {loaderNotifications ? (
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
                size="sm"
              />
            ) : (  */}
            <Dropdown>
              <Col
                xs="auto"
                className={
                  notifications && notifications.count > 0
                    ? "posicion_campana rounded px-2 text-light shadow d-block "
                    : "d-none"
                }
              >
                {notifications
                  ? notifications.count > 99
                    ? "+99"
                    : notifications.count
                  : "0"}
              </Col>

              <Dropdown.Toggle className="material-icons" id="dropdown-basic">
                {/*       <Spinner
                        variant="primary"
                        className="rounded-pill"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        align-items="right"
                      />s
                    */}
                notifications
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{
                  minHeight: "120px",
                  maxHeight: "200px",
                  width: "300px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  transform: "translate(-118px, 0px)",
                }}
                drop="up-centered"
              >
                {loaderNotifications ? (
                  <Col className="d-flex flex-wrap justify-content-center align-items-center">
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                    />
                  </Col>
                ) : (
                  <>
                    {notifications && notifications.data.length > 0 ? (
                      notifications.data.map((item, index) => (
                        <>
                          <Dropdown.Item
                            key={index}
                            className="py-1 mb-1"
                            onClick={() => {
                              dispatch(
                                notificationsRead(item.id, {
                                  leido: true,
                                })
                              );
                              history.push(`/notificaciones/${item.id}`);
                            }}
                          >
                            {item.asunto}
                          </Dropdown.Item>
                        </>
                      ))
                    ) : (
                      <Alert variant="info" className="mx-2 pl-3 pr-1">
                        No tiene notificaciones recientes
                      </Alert>
                    )}
                    <NavDropdown.Divider />
                    <Dropdown.Item
                      className="py-1 mb-1"
                      style={{ position: "fixed" }}
                      onClick={() => history.push(`/notificaciones`)}
                    >
                      Ver todo
                    </Dropdown.Item>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
            {/*          )} */}

            <Nav.Link href="#" disabled>
              <small>{userName}</small>
            </Nav.Link>
            <NavDropdown
              alignRight
              // title= {dispatch.user=== '' ? <i className="material-icons">face</i> : <img src={!!userPic ? userPic : userDefaultPerfil} className="user-pic" />}
              title={
                <img
                  src={!!userPic ? userPic : userDefaultPerfil}
                  className="user-pic"
                />
              }
              id="collasible-nav-dropdown"
            >
              <Link
                className="dropdown-item"
                to={`/perfil-usuario/${userId}/${userType}`}
              >
                Mi perfil
              </Link>
              {/* <Link className="dropdown-item" onClick={() => clearCacheData()}>
                Refrescar
              </Link> */}
              <NavDropdown.Divider />
              <NavDropdown.Item href="#" onClick={onSignOut}>
                Cerrar sesión
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default withRouter(CustomNavbar);
